<div class="banner banner-image mat-elevation-z1">
    <!--We could potentially create custom buttons on the quill toolbar-->
    <div class="content">
        <form *ngIf="status$ | async">
            <div *ngIf="isEditing; then edit; else readonly"></div>
        </form>
        <div *ngIf="isAdmin" class="buttons pull-right">
            <button
                *ngIf="isEditing"
                class="banner-btn"
                color="primary"
                mat-stroked-button
                (click)="submit()"
            >
                Save
            </button>
            <button
                class="banner-btn"
                mat-stroked-button
                (click)="toggleEdit()"
            >
                {{ isEditing ? "Cancel" : "Edit" }}
            </button>
        </div>
    </div>
</div>

<ng-template #readonly>
    <form [formGroup]="form">
        <quill-editor
            class="readonly"
            formControlName="status"
            [modules]="{ toolbar: false }"
            [styles]="quillStyle"
            [readOnly]="true"
            [placeholder]="''"
        ></quill-editor>
    </form>
</ng-template>

<ng-template #edit>
    <form [formGroup]="form">
        <quill-editor
            class="edit"
            formControlName="status"
            [styles]="quillStyle"
            [placeholder]="''"
        ></quill-editor>
    </form>
</ng-template>
